import React from 'react'

import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'

const NumberFormatCustom = ({
  value,
  displayType,
  suffix,
  thousandSeparator,
  decimalSeparator,
  decimalScale,
  fixedDecimalScale,
  placeholder,
  color,
  style,
}) => (
  <NumberFormat
    placeholder={placeholder}
    value={value}
    displayType={displayType}
    suffix={` ${suffix}`}
    thousandSeparator={thousandSeparator}
    decimalSeparator={decimalSeparator}
    decimalScale={decimalScale}
    fixedDecimalScale={fixedDecimalScale}
    style={{ color, ...style }}
  />
)

NumberFormatCustom.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  displayType: PropTypes.string,
  placeholder: PropTypes.string,
  suffix: PropTypes.string,
  thousandSeparator: PropTypes.string,
  decimalSeparator: PropTypes.string,
  decimalScale: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fixedDecimalScale: PropTypes.bool,
  color: PropTypes.string,
  style: PropTypes.object,
}

NumberFormatCustom.defaultProps = {
  value: '',
  displayType: 'text',
  suffix: '€',
  thousandSeparator: '.',
  decimalSeparator: ',',
  placeholder: '',
  decimalScale: '2',
  fixedDecimalScale: true,
  color: 'black',
  style: {},
}

export default NumberFormatCustom
